import { Component, Input, OnInit } from '@angular/core';
import { BaseNote, User } from '@authority-labs/api-interfaces';
import { PERMISSION_KEYS } from '@authority-labs/constants';
import { RequestQueryBuilder } from '@nestjsx/crud-request';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthenticationService } from '../../../auth/authentication.service';
import { AppPermissionsService } from '../../services/permissions/permissions.service';
import { CrudService } from '../../services/crud/crud.service';

@Component({
  selector: 'authority-labs-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  @Input() entityId: number;
  @Input() service: CrudService<BaseNote>;
  @Input() readonly: boolean;

  notes: BaseNote[] = [];
  note: BaseNote;
  processing = false;
  inputValue = '';
  user: User;

  constructor(
    private authService: AuthenticationService,
    private message: NzMessageService,
    private permissionsService: AppPermissionsService
  ) {
    this.user = this.authService.getUser();
  }

  ngOnInit(): void {
    this.note = {
      entityId: this.entityId,
      username: this.user.username
    };
    const queryParams = RequestQueryBuilder.create({
      filter: {
        field: 'entityId',
        operator: '$eq',
        value: this.entityId
      }
    }).query();

    this.service
      .getMany(queryParams)
      .subscribe((resp) => (this.notes = resp.data));
  }

  addNote(): void {
    this.processing = true;
    this.note.content = this.inputValue;
    this.inputValue = '';
    this.service.createOne(this.note).subscribe(this.onSuccess, this.onError);
  }

  canDelete(note: BaseNote): boolean {
    if (this.readonly || note.deletedAt !== null) {
      return false;
    }
    const isOwn = note.username === this.user.username;
    return (
      (isOwn &&
        this.permissionsService.has(PERMISSION_KEYS.NOTES_DELETE_OWN)) ||
      this.permissionsService.has(PERMISSION_KEYS.NOTES_DELETE_OTHERS)
    );
  }

  deleteNote(id: number): void {
    this.service
      .deleteOne(id)
      .subscribe(() => this.onDeleteSuccess(id), this.onError);
  }

  private onSuccess = (note: BaseNote) => {
    this.processing = false;
    this.notes = [...this.notes, note];
    this.message.create('success', 'הפעולה נשמרה בהצלחה');
  };

  private onDeleteSuccess = (id: number) => {
    this.processing = false;
    const note = this.notes.find((_note) => _note.id === id);
    note.deletedAt = new Date().toISOString();
  };

  private onError = () => {
    this.processing = false;
    this.message.create('error', 'הפעולה נכשלה', {
      nzDuration: 10000
    });
  };
}
